/** Состояние заявок на открытие эскроу счета. */
export enum EscrowRequestStates {
  // Принята на рассмотрение
  UnderConsideration = 0,

  // Отказана.
  Canceled = 1,

  // Договор сформирован.
  ContractPrepared = 2,

  // Оформление договора.
  ContractExecuting = 3,

}
